import { render, staticRenderFns } from "./ChatTool.vue?vue&type=template&id=3bb12e8c&scoped=true&"
import script from "./ChatTool.vue?vue&type=script&lang=js&"
export * from "./ChatTool.vue?vue&type=script&lang=js&"
import style0 from "./ChatTool.vue?vue&type=style&index=0&id=3bb12e8c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb12e8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb12e8c')) {
      api.createRecord('3bb12e8c', component.options)
    } else {
      api.reload('3bb12e8c', component.options)
    }
    module.hot.accept("./ChatTool.vue?vue&type=template&id=3bb12e8c&scoped=true&", function () {
      api.rerender('3bb12e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/ChatTool.vue"
export default component.exports